
<template>
    <div class="container">
        <div class="mapInfo" :style="infoStyle">
            <photoCarusel ref="fotoCarusel"></photoCarusel>
            <div>
                <span v-if="loading">Loading...</span>
            </div>
            <div class="mapInfoTitolo">
                
                <span>  {{ selectedNc.desAc }} ( {{ selectedNc.prgAc }})</span>
            </div>
            <div class="googleMap" v-show="selectedNc.latLng">
                <v-btn @click="openGoogleMap">Google maps</v-btn>
            </div>
            <v-expansion-panels v-model="expandedInterni" multiple >
                <v-expansion-panel v-for="(int, i) in selectedNc.interni" :key="i">
                    <v-expansion-panel-header class="internoHeader">
                        <table class="tableInternoHeader">
                            <tr>
                                <td class="primColonna"><span class="civico">{{ selectedNc.desNN }}</span>
<span class="interno" v-show="int.desIN != ''"> - int. {{ int.desIN }}</span></td>
<td><span v-show="int.scala !=''">Scala </span>{{ int.scala }}</td>
<td>    <div class="chipUso">
                        <nc-chip tipo="USO" :val="int.codUso"></nc-chip>
                    </div>
 </td>
                            </tr>
                        </table>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                        <!--Locatari e prop e dc -->
                        <table class="tableLocProp">
                            <!--loc-->
                            <tr v-for="loc in int.locatari" :v-bind="loc.prgLocatario" :key="'loc_' + loc.prgLocatario">
                                <td>
                                    <nc-chip tipo="LOC" val="L"></nc-chip>
                                </td>
                                <td>{{ loc.desLoc }}</td>
                                <td>
                                    <v-icon color="blue" @click="clickOnLoc(loc)"
                                        v-show="loc.tipo === 'PR' || loc.tipo === 'IMP'">mdi-arrow-right
                                    </v-icon></td>
                            </tr>
                            <!--prop-->
                            <tr v-for="prop in int.proprietari" :v-bind="prop.prgProprietario"
                                :key="'prop_' + prop.prgProprietario">
                                <td>
                                    <nc-chip tipo="PROP" val="P"></nc-chip>
                                </td>
                                <td>
                                    <div class="desProp">{{ prop.desProp }}</div>
                                    <div class="indProp">{{ prop.desIndirizzo }}</div>
                                </td>
                                <td>
                                    <v-icon color="blue" @click="clickOnProp(prop)"
                                        v-show="prop.tipo === 'PR' || prop.tipo === 'IMP'">mdi-arrow-right
                                    </v-icon></td>
                            </tr>
                            <!--dc-->
                            <tr>
                                <td>
                                    <nc-chip tipo="DC" val="C"></nc-chip>
                                </td>
                                <td class="tddc" style="padding:0">
                                    <table class="dc">
                                        <th title="Sezione catastale">Sez.</th>
                                        <th title="Foglio catastale">Fog.</th>
                                        <th title="Numero catastale">Mapp.</th>
                                        <th title="Subalterno catastale">Sub</th>
                                        
                                        <tr v-for="dc in int.dc" v-bind:key="'dcx_' + dc.mappale + '_' + dc.sub">
                                            <td title="Sezione catastale">{{dc.sezione}}</td>
                                            <td title="Foglio catastale">{{dc.foglio}}</td>
                                            <td title="Numero catastale">{{dc.mappale}}</td>
                                            <td title="Subalterno catastale">{{dc.sub}}</td>
                                        </tr>
                                    </table>
                                </td>
                            </tr>
                        </table>
                    </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel>
                    <v-expansion-panel-header class="fotoHeader">
                        <span class="interno"> Foto ({{ selectedNc.foto.length }}) </span></v-expansion-panel-header>
                    <v-expansion-panel-content>
                        <!-- FOTO-->
                        <div class="fotoContainer">
                            <div v-if="selectedNc.foto.length > 0" class="fotoItem" v-on:click="openFoto">
                                <img :src="selectedNc.foto[0].url + '/280'" aspect-ratio="1" class="grey lighten-2">
                            </div>
                            <div v-if="selectedNc.foto.length == 0" class="nofoto">
                                Foto non presente
                            </div>
                            
                        </div>
                    </v-expansion-panel-content>
                </v-expansion-panel>
                
            </v-expansion-panels>
        </div>
        <div class="mapDiv" style="">
            <mappa :listaAc="listaAc" ref="mappa" @onMarkerClick="onMarkerClick" :mapStyle="mapStyle"></mappa>
        </div>
    </div>
</template>

<script>

export default {
    props: {

        listaAc: { required: true },
        mapStyle: {
            required: true, default: '', type: String
        },
        infoStyle: {
            required: false, default: 'width:20rem', type: String
        },
    },
    data: () => ({
        loading: false,
        selectedNc: { interni: [], foto: [], variazioni: '', msgNc: '' },
        expandedInterni: [],
    }),
    methods: {
         getMapDiv(){
        
      return this.$refs.mappa.getMapDiv();
    },
        clickOnLoc(p){
            this.$emit('clickOnLoc',p);
        },
        clickOnProp(p){
            this.$emit('clickOnProp',p);
        },
        openGoogleMap() {
            var googleUrl = "https://www.google.com/maps/@?api=1&map_action=pano&viewpoint=" + this.selectedNc.latLng[0]
                + ',' + this.selectedNc.latLng[1];
            window.open(googleUrl, '_blank', 'noreferrer');
        },

        openFoto() {
            this.$refs.fotoCarusel.openWithNi(this.selectedNc.foto, this.selectedNc.latLng,this.selectedNc);
        },
        searchAc(prgAc, num) {
            this.$refs.mappa.searchAc(prgAc, num);
        },
        bindNc(p) {
            this.selectedNc = p;
            this.$refs.mappa.bindNc(p);
            this.expandedInterni=[1];
        },
        bindRilievo(p) {
            this.selectedNc = p;
            this.$refs.mappa.bindRilievo(p);
            this.expandedInterni=[1];
        },
        onMarkerClick(p) {
            this.selectedNc = p;
            this.expandedInterni=[1];
            this.$emit('onMarkerClick', p);
        }

    },

}
</script>

<style>
.mapInfoTitolo {
    padding-left: 0.3rem;
    padding-bottom: 0.2rem;
    padding-top: 0.2rem;


    font-weight: 700;
    color: whitesmoke;
}

.container {
    padding: 0;
    margin-top: 0rem;
    margin-left: 1px;
    float: left;
    display: flex;
    justify-content: flex-start;
    width: 90rem;
    min-width: 90rem;
    border: 0px solid yellow;
}

.fotoContainer {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    width: 14rem;
    height: 12rem;
    border: 0px solid red;
}

.fotoItem {
    height: 12rem;
    width: 12rem;
    margin: 2px;
}

.v-expansion-panel-header {
    margin-bottom: 1px;
}

.mapInfo {
    overflow: auto;
    margin: 0rem;
    padding: 0.1rem;
    background-color: black;
}

.googleMap button {
    border: 2px solid gray;
    border-radius: 44px;
    margin-bottom: 6px;
    margin-top: 6px;
    color: whitesmoke !important;
    ;

}
table.dc th{
  font-weight: 600;
  text-align: center;
  border: 1px solid gray;
  color: whitesmoke;
  
}
table.dc{
  border-collapse: collapse;
  width:100%;
}
table.dc td{
  padding: 8px;
  border: 1px solid #5c5b58;
  width: 4rem;
  text-align: center;
}
.tableLocProp {
  border-collapse: collapse;
}
.tableLocProp td{
  border: 1px solid #5c5b58 !important;;
  padding: 0.6rem !important;;
  border-collapse: collapse;
}
table.tableLocProp td.tddc{
	
    padding: 0 !important;;
    border: 0px solid #5c5b58 !important;;
    width: 100%;
    text-align: center;
  }
  .tableInternoHeader td.primColonna{
  _border: 1px solid gray;
  _border-radius: 8px;
  _background-color: #555555;
  padding: 4px;
  padding-left:12px;
  padding-right:12px;
    
  _width: 7rem;
  font-size: 0.9rem;
  font-weight: 600;

}
.nofoto{
  border: 2px double #5f9ea0;
  
  width: 18rem;
  height: 13rem;
  background-color: gray !important;;
  padding-top:3rem;
  padding-left:  1.8rem;
    color: black;
  font-size: 1rem;
  font-weight: 600;
}
.v-expansion-panel{
    background-color: 3f3a3ae8 !important;
}
.v-expansion-panel-header--active{
    background-image: linear-gradient(to left,#4f5450,black ) ;
  height: 3rem !important;;
  min-height: 3rem !important;;
  border: 1px solid white !important;;
}
.v-expansion-panel--active:not(:first-child), .v-expansion-panel--active  .v-expansion-panel {
  margin-top: 0rem !important;;
  
  }

.internoHeader:first-of-type{
  border-top:1px solid gray !important;;
}
.internoHeader,.fotoHeader{
  background-color: black;
  border-bottom:  1px solid medium !important;;
  border-top:0px !important;
  border-radius: 8px;
  padding-top: 4px !important;;
  padding-bottom: 4px !important;;
  padding-left: 2px !important;; 
}

</style>